// import React from "react";
import Admin from "layouts/Admin";
import React, { useEffect, useState } from "react";
import Footer from "components/Footer/Footer";
// import Background from 'assets/img/a.jpg';


// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
} from "react-bootstrap";

import firebase from "../firebase";

function User() {

  const[aCompany,setAcompany] = useState('');
  const[aNIC,setAnic] = useState('');
  const[aEmail,setAemail] = useState('');
  const[aFirstname,setAfirstname] = useState('');
  const[aLastname,setAlastname] = useState('');
  const[aAddress,setAadress] = useState('');
  const[aCity,setAcity] = useState('');
  const[aCountry,setAcountry] = useState('');
  const[aAge,setAage] = useState('');
  const[aAbtme,setAabtme] = useState('');

  const handleAddUser = () => {

   
    const firestore = firebase.database().ref("/reqforaprooval");
    let data = {
     
      Company: aCompany,
      NIC: aNIC,
      Email: aEmail,
      FirstName: aFirstname,
      LastName: aLastname,
      Address: aAddress,
      City: aCity,
      Country: aCountry,
      Age: aAge,
      AboutMe: aAbtme,

    }
    console.log(data);
    firestore.push(data);

    alert("Succfully inserted");
    setAcompany("");
    setAnic("");
    setAemail("");
    setAfirstname("");
    setAlastname("");
    setAadress("");
    setAcity("");
    setAcountry("");
    setAage("");
    setAabtme("");
   };





  return (
    <>

    

<Admin/>

<br/>

<Container>
  <Row>
    <Col md={{ span: 12, offset: 1 }}>  





      <Container fluid>
        <Row>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Request For Aprooval</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                    <Col className="pr-1" md="5">
                      <Form.Group>
                        <label>Company</label>
                        <Form.Control
                          focus value = {aCompany} onChange={(e)=>{setAcompany(e.target.value)}}
                          placeholder="Company"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="3">
                      <Form.Group>
                        <label>NIC</label>
                        <Form.Control
                          focus value = {aNIC} onChange={(e)=>{setAnic(e.target.value)}}
                          placeholder="NIC"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label htmlFor="exampleInputEmail1"  >
                          Email address
                        </label>
                        <Form.Control
                          focus value = {aEmail} onChange={(e)=>{setAemail(e.target.value)}}
                          placeholder="Email"
                          type="email"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <label>First Name</label>
                        <Form.Control
                          focus value = {aFirstname} onChange={(e)=>{setAfirstname(e.target.value)}}
                          placeholder="First Name"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="6">
                      <Form.Group>
                        <label>Last Name</label>
                        <Form.Control
                          focus value = {aLastname} onChange={(e)=>{setAlastname(e.target.value)}}
                          placeholder="Last Name"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>Address</label>
                        <Form.Control
                          focus value = {aAddress} onChange={(e)=>{setAadress(e.target.value)}}
                          placeholder="Home Address"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="4">
                      <Form.Group>
                        <label>City</label>
                        <Form.Control 
                          
                          focus value = {aCity} onChange={(e)=>{setAcity(e.target.value)}}
                          placeholder="City"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="4">
                      <Form.Group>
                        <label>Country</label>
                        <Form.Control
                          focus value = {aCountry} onChange={(e)=>{setAcountry(e.target.value)}}
                          placeholder="Country"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label>Age</label>
                        <Form.Control
                          focus value = {aAge} onChange={(e)=>{setAage(e.target.value)}}
                          placeholder="age"
                          type="number"
                          
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>About Me</label>
                        <Form.Control
                          cols="80"
                          focus value = {aAbtme} onChange={(e)=>{setAabtme(e.target.value)}}
                          placeholder="description about you"
                          rows="4"
                          as="textarea"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Button
                    onClick={()=>{handleAddUser()}}
                    className="btn-fill pull-right"
                    type="button"
                    variant="info"
                  >
                    Submit
                  </Button>
                  <div className="clearfix"></div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          
        
        </Row>
      </Container>


    
      </Col>
  </Row>
</Container>

 <Footer /> 



    </>
  );
}




export default User;
